import { Component } from '@angular/core';
import {
  DsButtonModule,
  DsColumnData,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsRowData,
} from '@bmw-ds/components';
import { PricePerBodyResponse } from '../../../models/price-per-body.model';
import { NgForOf } from '@angular/common';

@Component({
  selector: 'app-model-pricing-modal',
  templateUrl: './model-pricing-modal.html',
  imports: [DsModalModule, NgForOf, DsButtonModule],
  styleUrls: ['./model-pricing-modal.scss'],
})
export class ModelPricingModalComponent {
  constructor(private readonly loadingAreaService: DsLoadingAreaService) {}
  isOpen = false;
  modelPricingData = {
    modelName: '',
    price: '',
    currency: '',
  };

  modelPricingModalIsOpen: boolean = false;
  pricePerBodyResponse!: PricePerBodyResponse;
  rowsData: DsRowData[] = [];
  columnData: DsColumnData[] = [
    { field: 'options', headerName: 'Model/Option' },
    { field: 'description', headerName: 'Description' },
    { field: 'billing', headerName: 'Dealer Billing' },
    { field: 'retailPrice', headerName: 'Retail Price' },
  ];
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  // ngOnInit(): void {
  //   this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
  //   this.processPricePerBodyResponse(this.pricePerBodyResponse);
  // }

  openModal(data: any): void {
    this.modelPricingData = data; // Set the data to be displayed in the modal
    this.isOpen = true;
  }

  closeModal(): void {
    this.modelPricingModalIsOpen = false;
    // this.modelPricingData = null; // Clear the data when closing the modal
  }

  processPricePerBodyResponse(response: PricePerBodyResponse): void {
    this.pricePerBodyResponse = response;
    this.rowsData = response.listoptstab.map((item) => ({
      options: item.modelopt,
      description: item.description,
      billing: item.price,
      retailPrice: item.retailprice,
    }));
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }
}
